/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { colors } from "./colors";
import { Fragment } from "react";

type Props = {
  tabs: string[];
  tabPanels: React.ReactNode[];
  defaultChosenTab?: number;
};

const tabListStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  align-items: center;
`;

const tabPanelsStyle = css`
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
  width: 100%;
`;

const tabGroupStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Tabs = ({ tabs, tabPanels, defaultChosenTab }: Props) => {
  return (
    <TabGroup css={tabGroupStyle} defaultIndex={defaultChosenTab}>
      <TabList as="div" css={tabListStyle}>
        {tabs.map((tab, i) => (
          <Tab as={Fragment} key={i}>
            {({ active, hover, selected, focus }) => (
              <div
                css={css`
                  display: flex;
                  padding: 4px 12px;
                  cursor: pointer;
                  border-radius: 9999px;
                  ${(focus || active) &&
                  `outline: 2px solid ${colors.blueLight} !important; outline-offset: 2px !important;`}
                  color: ${active || selected || hover
                    ? colors.textPrimary
                    : colors.textSecondary};
                  background-color: ${active || selected
                    ? colors.white
                    : colors.transparent};
                  ${selected &&
                  `box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06),
                    0px 0px 0px 1px rgba(0, 0, 0, 0.08);`}
                `}
              >
                {tab}
              </div>
            )}
          </Tab>
        ))}
      </TabList>
      <TabPanels css={tabPanelsStyle}>
        {tabPanels.map((tabPanel, i) => (
          <TabPanel key={i}>{tabPanel}</TabPanel>
        ))}
      </TabPanels>
    </TabGroup>
  );
};
